import styled from 'styled-components';

import { Input as AntdInput } from 'antd';

import { inputStylesOverride } from './BaseInput';

const Password = styled(AntdInput.Password)`
    ${inputStylesOverride};
`;

export default Password;
